import { MarkdownViewer } from "@client/components/round/allocator/MarkdownViewer";
import { authReturnPath } from "@lib/authReturnPath";
import { useSearchParams } from "wouter";
import policy from "./privacy-policy.md?raw";

export function PrivacyPage() {
  const [searchParams] = useSearchParams();
  const returnTo = authReturnPath(searchParams.get("returnTo"));

  return (
    <div className="h-dvh overflow-y-auto bg-background text-foreground">
      <title>Privacy Policy | S-Process</title>
      <main className="mx-auto w-full max-w-3xl px-6 py-10 sm:px-8 sm:py-16 [overflow-wrap:anywhere]">
        <a
          href={returnTo}
          className="mb-8 inline-flex min-h-11 items-center rounded-sm body-sm text-muted-foreground underline underline-offset-4 hover:text-foreground focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-ring"
        >
          Back to S-Process
        </a>
        <article className="prose max-w-none dark:prose-invert prose-headings:text-foreground prose-p:text-foreground prose-a:text-foreground prose-h1:text-heading-xl prose-h2:text-heading-lg">
          <MarkdownViewer value={policy} />
        </article>
      </main>
    </div>
  );
}
